import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/root';
import { dispatch } from '../../../redux/store';
import { setShowConfirmDelete } from '../../../redux/slices/wikiKeysSlice';
import { useDeleteWikiKeyMutation } from '../../../redux/rtkQuery/apiWikiKeysSlice';
import { resetKeyData } from './utils';

const ConfirmDeletePopup = () => {
  const { showConfirmDelete, keyId } = useSelector((s: RootState) => s.wikiKeysSlice);
  const [deleteWikiKey] = useDeleteWikiKeyMutation();

  const onNo = () => {
    dispatch(setShowConfirmDelete(false));
  };
  const onYes = async () => {
    const result: any = await deleteWikiKey({ id: keyId });
    if (result.data?.message === 'Key marked as deleted.') {
      resetKeyData(dispatch);
    }
    dispatch(setShowConfirmDelete(false));
  };

  if (!showConfirmDelete) return null;

  return (
    <Overlay>
      <ConfirmDelete>
        {keyId ? (
          <span>Are you sure you want to delete?</span>
        ) : (
          <span>No Key - Nothing to delete</span>
        )}
        {!keyId ? (
          <ConfirmButtons>
            <Button onClick={onNo}>Close</Button>
          </ConfirmButtons>
        ) : (
          <ConfirmButtons>
            <Button onClick={onNo}>No</Button>
            <Button onClick={onYes}>Yes</Button>
          </ConfirmButtons>
        )}
      </ConfirmDelete>
    </Overlay>
  );
};

export default ConfirmDeletePopup;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ConfirmDelete = styled.div`
  width: 280px;
  padding: 20px;
  border: 1px solid grey;
  border-radius: 7px;
  background-color: #fff;
  box-shadow: 5px 5px var(--defaultTableCellTitle);
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: center;
`;

const ConfirmButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid var(--border);
  gap: 7px;
  padding: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
  cursor: pointer;
  min-width: 97px;
  justify-content: center;
  &:hover {
    background-color: var(--defaultTableCell);
  }
  &:active {
    background-color: var(--disabledButton);
  }
`;
